
import { useEffect } from "react";
import { CartItem as CartItemComponent } from "./CartItem";
import { CartItem } from "@/contexts/CartContext";

interface CartItemsProps {
  items: CartItem[];
  onUpdateQuantity: (id: string, quantity: number) => void;
  onRemoveItem: (id: string) => void;
}

export const CartItems = ({ items, onUpdateQuantity, onRemoveItem }: CartItemsProps) => {
  useEffect(() => {
    // Log image information for debugging purposes
    console.log('Cart items with images:');
    items.forEach(item => {
      console.log(`- ${item.name} (${item.id}): ${item.image}`);
    });
  }, [items]);
  
  return (
    <div className="space-y-4">
      {items.map((item) => (
        <CartItemComponent
          key={item.id}
          item={item}
          onUpdateQuantity={onUpdateQuantity}
          onRemoveItem={onRemoveItem}
        />
      ))}
    </div>
  );
};
